import { MetalLevel, TierLevel } from '@zorro/clients';
import { Box } from '@zorro/web/design-system';

import classNames from './MetalLevelMark.module.scss';

type Props = {
  metalLevel?: MetalLevel | TierLevel;
  size?: number;
};

export const MetalLevelMark = ({ metalLevel, size }: Props) => {
  if (!metalLevel) {
    return null;
  }

  return (
    <Box
      className={classNames.root}
      data-variant={metalLevel}
      w={size}
      miw={size}
      h={size}
    />
  );
};
